import { useState } from 'react';
import { useSelector } from 'react-redux';
import AssessmentsList from './AssessmentsList';
import TableTitle from '../../Shared/Table/widgets/TableTitle';
import TablePageContainer from '../../Shared/Table/widgets/TablePageContainer';

const Assessments = () => {
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(' ');
  const { en: { titles } } = useSelector((state) => state.i18n);

  return <TablePageContainer>
    <AssessmentsList
      setFilterStyle={setFilterStyle}
      setTotalCount={setTotalCount}
      tableTitle={<TableTitle
        titleText={titles.assessments}
        count={totalCount}
        countFiltered={filterStyle}
      />}
    />
  </TablePageContainer>;
};

export default Assessments;
